export const appointmentBook = {
  nationalId: "",
  nationalIdUrl: "",
  insurance: {
    provider: "",
    membershipNo: "",
  },
  symptoms: [],
 
  surgeries: [],
  medicalConditions: [],
  patientHeight: "100",
  firstName: "",
  reasonForVisit: "",
  notesToDoctor: "",
  weightMeasurement: "kg",
  noOfBooking: 1,
  bookingFrom: "AppointmentBooking",
  reminderNumber: "",
  appointmentFor: "",
  reports: "",
  blockId: "",
  basicFees: "100.00",
  surgerydetails: [],
  referenceId: "",
  allergies: [],
  gender: "Male",
  appointmentDate: "",
  emergencyname: "",
  relationship: "",
  patientWeight: "200",
  dob: "",
  heightMeasurement: "cm",
  medications: [],
  emergencyrelation: "",
  dentalInfo: "[]",
  bookingType: "",
  fees: "",
  hospitalid: "",
  typeofconsultation: "",
  doctorId: "",
  emergencyphone: "",
  status: "",
  modeOfConsultation: "Video",
  duration: "15",
  appointmentTime: "",
  lastName: "",
  gstamount: "",
  duration: "",
  reportsArray: [],
  reasonForVisitIndex: null,
  nationalIdfile: "",
  routing: false,
  countryCode: "91",
  alternativeCode: "91",
  emergencyNoCode: "91",
  medicineupdate :"No",
  allergiesupdate :"No",
  medicalconditionupdate :"No",
  symptomsupdate :"No",
  surgeryupdate :"No",
};


export const selectedStates = {
  symptoms:"No"
}
